import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import ReturnAuthorizationModel from "models/ReturnAuthorizationModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';
import SearchTransactionDto from "models/SearchTransactionDto";

import { getAuthorizedApi, processAxiosError, urlBuilder } from "services/common.service";
import { setResultsDtoBase } from "reducers/dto.slice";


export const getReturns = createAsyncThunk('returns/getReturns',
    async (searchDto: SearchTransactionDto, { dispatch }) => {
        try {
            const url = urlBuilder('/Returns/GetReturns', searchDto);

            const response = await getAuthorizedApi().get<ResultsDtoModel<ReturnAuthorizationModel>>(url);
            const data = response.data;

            dispatch(setResultsDtoBase({
                totalResults: data.totalResults,
                offset: data.offset,
                page: data.page
            }));

            return data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
        }
        return initialResultsDtoModel;
    });